export default __webpack_public_path__ + "static/media/pic2.ed64d2d0.png";